export const VERIFICATION_METHODS = {
  CALL: "voice",
  TEXT: "sms"
};
